<div class="ipm-audi-player" id="ipm-audio-container" [class.ipm-showPlayer]="isOpenMusicPlayer" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
    <div class="ipm-dynamic-bg" *ngIf="currentPlayBeat?.cover_picture" [style.background-image]="'url(' + currentPlayBeat.cover_picture + ')'"></div>
    <div class="ipm-dynamic-overlay" *ngIf="currentPlayBeat?.cover_picture"></div>
    <div class="ipm-range ipm-music-slider music-main-slider" (touchstart)="onSeekTouchStart($event)" (touchend)="onSeekTouchEnd($event)" (touchcancel)="onSeekTouchEnd($event)">
        <mat-slider  id="seek-obj"
            min="0"
            [max]="state.duration"
            step="0.01"
            class="ipm-custom-music-player"
            [disabled]="state.error || currentIndex === undefined"
            aria-label="Seek position">
            <input matSliderThumb [(ngModel)]="seekDisplayTime" (dragEnd)="onSliderChangeEnd($event)" (change)="onSliderChange($event)" (input)="onSliderInput($event)" #slider>
        </mat-slider>
        <!-- Diwali sale live: phuljhari (sparkler) on the seek head: glowing trail, hot core, sparks with crackle and falling embers; sparks only while playing -->
        <div class="ipm-phuljhari-track" *ngIf="commonService.isSaleActive() && state?.duration" aria-hidden="true">
            <span class="ipm-phuljhari-trail" [class.is-playing]="state.playing" [style.width.%]="phuljhariLeft"></span>
            <div class="ipm-phuljhari" [class.is-playing]="state.playing" [style.left.%]="phuljhariLeft">
                <span class="ipm-phuljhari-halo"></span>
                <span class="ipm-phuljhari-spark" *ngFor="let spark of phuljhariSparks" [class.has-crackle]="spark.crackle"
                    [style.--a]="spark.angle + 'deg'" [style.--d]="spark.dist + 'px'" [style.--c]="spark.color"
                    [style.height.px]="spark.length" [style.animation-delay.s]="spark.delay" [style.animation-duration.s]="spark.duration"></span>
                <span class="ipm-phuljhari-ember" *ngFor="let ember of phuljhariEmbers"
                    [style.--ex]="ember.dx + 'px'" [style.--ey]="ember.dy + 'px'"
                    [style.animation-delay.s]="ember.delay" [style.animation-duration.s]="ember.duration"></span>
                <span class="ipm-phuljhari-core"></span>
            </div>
        </div>
    </div>
    <div class="mobile-view-ipm-timer">
        <span class="ipm-start">{{state.readableCurrentTime}}</span>
        <span class="ipm-end">{{state.readableDuration}}</span>
    </div>
    <div class="ipm-audio-content">
        <div class="ipm-middle-section ipm-common-width">
            <div class="ipm-beat-music-details">
                <div class="ipm-image-wrapper" [class.ipm-music-play]="state.playing">
                    <img priority [src]="currentPlayBeat ?  currentPlayBeat.cover_picture : ''" alt="beat-cover" class="ipm-img-cover" width="64" height="64">
                    <span class="ipm-disc-badge" *ngIf="currentPlayBeat?.sale_info?.is_on_sale &&commonService.isBeatOnSale(currentPlayBeat)">{{currentPlayBeat.sale_info.discount_tier}}%</span>
                    <ng-container [ngTemplateOutlet]="uploadLoadingShow" *ngIf="isShowLoader && !state.playing" ></ng-container>
                    <ipm-equalizer-animation *ngIf="state.playing"></ipm-equalizer-animation>
                </div>
                <div class="ipm-beat-info" *ngIf="currentPlayBeat" [ngClass]="slideAnimationClass">
                    <div class="ipm-beat-name" (click)="handleRouting('/bt-'+currentPlayBeat.serial_number, 'beatList')">{{currentPlayBeat ?  currentPlayBeat.title : ''}}</div>
                    <div class="ipm-beat-other">
                        <span class="ipm-beat-artist" (click)="handleRouting('/'+currentPlayBeat.created_by.handle, 'producerProfile')">{{currentPlayBeat ?  currentPlayBeat.created_by.name : ''}}
                            <span class="ipm-store-name">  {{currentPlayBeat ?  currentPlayBeat.producer.store.general?.name : ''}}</span>
                            <img class="ipm-verify-icon" *ngIf="(currentPlayBeat.producer?.tiers | getSubsTires : 'producer') === 'tier1'" priority src="./assets/imgs/subs_premium_tick.svg"
                            alt="verify-icon">
                            <img class="ipm-verify-icon " *ngIf="(currentPlayBeat.producer?.tiers | getSubsTires : 'producer') === 'tier2'" priority src="./assets/imgs/subs_pro_tick_img.png"
                            alt="verify-icon">
                        </span>
                        <div class="ipm-tempo-section">
                            <span class="ipm-tempo"><img priority src="./assets/imgs/sub-menu/beat-play.png" alt="beat-play"> {{currentPlayBeat ?  currentPlayBeat.tempo : ''}} BPM</span>
                            <span class="ipm-play-span" ><i class="fa fa-play" aria-hidden="true"></i>{{currentPlayBeat.play_count ?  commonService.nFormatter(currentPlayBeat.play_count, 1) : 0}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ipm-first-section ipm-common-width">
            <div class="ipm-action">
                <i class="pi pi-share-alt" (click)="openBeatShareDialogBox()"></i>
                <i class="pi pi-download" (click)="openBeatDownloadDialogBox()" *ngIf="currentPlayBeat && !currentPlayBeat.disable_mp3_download"></i>
                <i class="pi"
                [class.pi-heart]="currentPlayBeat && !currentPlayBeat.isFav"
                [class.pi-heart-fill]="currentPlayBeat && currentPlayBeat.isFav"
                [class.pi-heart-fill-color]="currentPlayBeat && currentPlayBeat.isFav"
                (click)="addORemoveBeatIntoFavList()"></i>
            </div>
            <div class="ipm-controls-audio">
                <button class="btn" (click)="previous()" aria-label="backward">
                    <i class="fa fa-step-backward" aria-hidden="true"></i>
                </button>
                <ng-container *ngIf="!isShowLoader else loaderTemplate">
                    <i class="fa fa-play-circle ipm-play-pause" aria-hidden="true" (click)="songPlay(state.playing)" *ngIf="!state.playing" role="button"></i>
                    <i class="fa fa-pause-circle ipm-play-pause" aria-hidden="true" *ngIf="state.playing" (click)="songPlay(state.playing)" role="button"></i>
                </ng-container>

                <ng-template #loaderTemplate>
                    <div class="ipm-play-pause" *ngIf="isShowLoader && !state.playing">
                        <ng-container [ngTemplateOutlet]="uploadLoadingShow" ></ng-container>
                    </div>
                </ng-template>

                <button class="btn" (click)="next()" aria-label="forword">
                    <i class="fa fa-step-forward" aria-hidden="true"></i>
                </button>
            </div>
            <div class="ipm-timer">
                <span class="ipm-start">{{state.readableCurrentTime}}</span>
                <span class="ipm-slash"></span>
                <span class="ipm-end">{{state.readableDuration}}</span>
            </div>
        </div>
        <div class="ipm-last-section ipm-common-width">
            <div class="ipm-lyrics-icon" *ngIf="currentPlayBeat && isUserLoggedIn" (click)="openLyricsEditor()">
                <img src="https://ip-dev.s3.ap-south-1.amazonaws.com/Icons/lyrics-pen.svg"
                    alt="lyrics" width="18" height="18" class="ipm-icon-white">
            </div>
            <div class="ipm-repeat" [class.ipm-repeat-on]="isAudioLoop" (click)="isMusicLoop()">
                <img priority src="./assets/imgs/repeat-icon.png" alt="repeat-icon" width="18" height="18">
            </div>
            <div class="ipm-volume">
                <i class="fas"  [class.fa-volume-down] = "!isAudioMute" [class.fa-volume-mute] = "isAudioMute"  aria-hidden="true" (click)="volumeMute()"></i>
                <div class="ipm-range ipm-music-slider" (touchstart)="$event.stopPropagation()" (touchmove)="$event.stopPropagation()" (touchend)="$event.stopPropagation()">
                    <mat-slider
                        id="volume"
                        min="0"
                        max="1"
                        step="0.01"
                        class="ipm-custom-music-player"
                        aria-label="Volume Control">
                        <input matSliderThumb [(ngModel)]="state.volume" (input)="onVolumeChange(state.volume)" aria-label="Volume control" #slider>
                    </mat-slider>
                </div>
            </div>
            <div class="ipm-price-wrap" *ngIf="isShowPriceOptions">
                <button class="btn ipm-price-btn"  (click)="openPricePopup()" [class.ipm-sale-price-btn]="commonService.isBeatOnSale(currentPlayBeat)">
                <i class="pi pi-shopping-cart"></i>
                <ng-container *ngIf="currentPlayBeat">
                    <ng-container *ngIf="commonService.isBeatOnSale(currentPlayBeat); else saleNotActive">
                            <span>{{(currentPlayBeat.prices | getPriceValue : 'single': '':  'sale') | currency:'INR':'symbol':'1.0-0'}}</span>
                        </ng-container>
                        <ng-template #saleNotActive>
                            <span>{{(currentPlayBeat.prices | getPriceValue : 'single') | currency:'INR' : 'symbol' : '1.0-0'}}</span>
                        </ng-template>
                </ng-container>
            </button>
                <span class="ipm-price-orig" *ngIf="commonService.isBeatOnSale(currentPlayBeat)">{{(currentPlayBeat.prices | getPriceValue : 'single') | currency:'INR':'symbol':'1.0-0'}}</span>
            </div>
            <span class="ipm-up-arrow" *ngIf="currentPlayBeat && isShowPriceOptions">
                <img src="./assets/imgs/icons/cart.svg" alt="cart" class="ipm-cart-icon" (click)="openPricePopup()">
            </span>
            <div class="ipm-more-mob-button">
                <span>
                    <i class="pi pi-ellipsis-v" [matMenuTriggerFor]="ipmContent" role="button" tabindex="0" aria-label="Open menu"></i>
                </span>
            </div>
        </div>
    </div>

</div>


<mat-menu #ipmContent="matMenu" [class]="'ipm-custom-menu'">
    <ng-template matMenuContent>
        <button mat-menu-item (click)="openBeatShareDialogBox()">
            <span><i class="pi pi-share-alt"></i> Share</span>
        </button>
        <button mat-menu-item (click)="openBeatDownloadDialogBox()" *ngIf="currentPlayBeat &&  !currentPlayBeat.disable_mp3_download">
            <span><i class="pi pi-download"></i> Download</span>
        </button>
        <button mat-menu-item
        (click)="addORemoveBeatIntoFavList()">
            <span><i class="pi pi-heart"
                [class.pi-heart]="currentPlayBeat && !currentPlayBeat.isFav"
                [class.pi-heart-fill]="currentPlayBeat && currentPlayBeat.isFav"
                [class.pi-heart-fill-color]="currentPlayBeat && currentPlayBeat.isFav"></i>
                Favorite
            </span>
        </button>
        <button mat-menu-item (click)="openLyricsEditor()" *ngIf="currentPlayBeat && isUserLoggedIn">
            <span>
                <img src="/assets/imgs/icons/lyrics-pad.svg"
                    alt="lyrics" width="16" height="16" class="ipm-icon-white" style="vertical-align: -2px;" />
                Lyrics
            </span>
        </button>
        <button mat-menu-item (click)="isMusicLoop()">
            <span>
                <div class="mobile-ipm-repeat" [class.ipm-repeat-on]="isAudioLoop" >
                    <img priority src="./assets/imgs/repeat-icon.png" alt="repeat-icon" width="18" height="18">
                </div>
                Repeat
            </span>
        </button>
    </ng-template>
</mat-menu>

<ipm-common-beats-dialog (nonLoginAlert)="showLoginAlert($event)" (onTriggerPlayEvent)="handlePlayPause($event)" #commonSharedCop></ipm-common-beats-dialog>
<ng-template #loginAlertUserPopup let-data>
	<ipm-non-login-user-popup [type]="data.type"></ipm-non-login-user-popup>
</ng-template>

<ng-template #uploadLoadingShow>
    <div class="isShowProgressMusic">
        <div class="loading-show">
            <ipm-loading-spinner [isShowBeatLoading]="true"></ipm-loading-spinner>
        </div>
    </div>
</ng-template>
